import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export function PromoCodeDialog({
  open, onOpenChange, editingPromo, promoForm, setPromoForm,
  handlePromoSubmit, saving,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-heading">{editingPromo ? "Edit Promo Code" : "Create Promo Code"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handlePromoSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Code *</Label>
            <Input value={promoForm.code} onChange={(e) => setPromoForm(prev => ({ ...prev, code: e.target.value.toUpperCase() }))} placeholder="SUMMER20" required className="rounded-xl font-mono" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Discount Type</Label>
              <Select value={promoForm.discount_type} onValueChange={(v) => setPromoForm(prev => ({ ...prev, discount_type: v }))}>
                <SelectTrigger className="rounded-xl"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="percentage">Percentage (%)</SelectItem>
                  <SelectItem value="fixed">Fixed Amount (GHS)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Discount Value *</Label>
              <Input type="number" step="0.01" value={promoForm.discount_value} onChange={(e) => setPromoForm(prev => ({ ...prev, discount_value: e.target.value }))} placeholder={promoForm.discount_type === 'percentage' ? '20' : '10'} required className="rounded-xl" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Min Order (GHS)</Label>
              <Input type="number" step="0.01" value={promoForm.min_order_amount} onChange={(e) => setPromoForm(prev => ({ ...prev, min_order_amount: e.target.value }))} placeholder="Optional" className="rounded-xl" />
            </div>
            <div className="space-y-2">
              <Label>Max Uses</Label>
              <Input type="number" value={promoForm.max_uses} onChange={(e) => setPromoForm(prev => ({ ...prev, max_uses: e.target.value }))} placeholder="Unlimited" className="rounded-xl" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Valid Until</Label>
            <Input type="date" value={promoForm.valid_until} onChange={(e) => setPromoForm(prev => ({ ...prev, valid_until: e.target.value }))} className="rounded-xl" />
          </div>
          <div className="flex items-center justify-between py-2">
            <Label htmlFor="first_order_only">First Order Only</Label>
            <Switch id="first_order_only" checked={promoForm.first_order_only} onCheckedChange={(c) => setPromoForm(prev => ({ ...prev, first_order_only: c }))} />
          </div>
          <div className="flex items-center justify-between py-2">
            <Label htmlFor="is_active">Active</Label>
            <Switch id="is_active" checked={promoForm.is_active} onCheckedChange={(c) => setPromoForm(prev => ({ ...prev, is_active: c }))} />
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-xl">Cancel</Button>
            <Button type="submit" className="rounded-xl bg-primary" disabled={saving}>
              {saving ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Saving...</> : editingPromo ? "Update" : "Create"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
